import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { from, Observable } from 'rxjs';

export class NoCacheTranslateLoader implements TranslateLoader {
    constructor(
        private readonly prefix = './assets/i18n/',
        private readonly suffix = '.json',
    ) {}

    getTranslation(lang: string): Observable<TranslationObject> {
        // Translation files are not content-hashed, so always revalidate with the server
        // (cheap 304 when unchanged) to pick up new keys right after a deploy.
        return from(
            fetch(`${this.prefix}${lang}${this.suffix}`, { cache: 'no-cache' }).then(res => {
                if (!res.ok) {
                    throw new Error(`Failed to load translations for "${lang}": ${res.status}`);
                }
                return res.json();
            }),
        );
    }
}
